import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from 'react';
import { theme } from 'theme';
import { SdmTypography } from 'components';

import { IconButton } from '@material-ui/core';

import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';

import { styled } from '@material-ui/core/styles';

const DropDownContainer = styled('div')({
  width: '100%',
  margin: '0 auto',
});

const DropDownArrow = styled('span')({
  marginBottom: 1,
});

const DropDownHeader = styled('div')({
  marginBottom: '0.8em',
  borderBottom: `2px solid ${theme.colors.primary.black}`,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

const DropDownListContainer = styled('div')({
  zIndex: '100',

  '& > div::-webkit-scrollbar': {
    width: 6,
  },
  '& > div::-webkit-scrollbar-track': {
    background: '#ffffff',
  },
  '& > div::-webkit-scrollbar-thumb': {
    background: 'rgba(149, 152, 154, 0.43)',
    borderRadius: 5,
  },
  '& > div::-webkit-scrollbar-thumb:hover': {
    background: 'rgba(149, 152, 154, 1)',
  },
});

const DropDownList = styled('div')({
  marginBottom: '20px',
  padding: 10,
  background: '#ffffff',
  boxShadow: '0 6px 12px rgb(0 0 0 / 18%)',
  maxHeight: '266px',
  overflowY: 'scroll',
  color: `${theme.colors.primary.black}`,
});
const ListItem = styled('div')({
  listStyle: 'none',
  //   marginBottom: '0.8em',
  padding: ' 5px 15px',
  '&:hover': {
    color: `${theme.colors.primary.red}`,
    cursor: 'pointer',
  },
});

/* eslint-disable */
export const FilterSelect = forwardRef(
  (
    {
      options,
      labelKey,
      label,
      optionDescriptionCallback,
      resetLabel = '-',
      onSelect,
      initialValue,
      isCustomOpen,
      hideResetLabel = false,
      invertResetLabel = false,
      customFont = false,
    },
    ref
  ) => {
    useImperativeHandle(ref, () => ({
      customReset() {
        setSelectedOption(null);
      },
      setInitialValue(value) {
        setSelectedOption(value);
      },
    }));

    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(initialValue);

    const toggling = () => setIsOpen(!isOpen);

    const onOptionClicked = (value) => {
      setSelectedOption(value);
      setIsOpen(false);
      onSelect && onSelect(value);
    };

    useEffect(() => {
      if (isCustomOpen) setIsOpen(true);
    }, [isCustomOpen]);

    const getLabel = () => {
      return selectedOption && selectedOption !== resetLabel
        ? optionDescriptionCallback
          ? optionDescriptionCallback(selectedOption)
          : selectedOption[`${labelKey}`]
        : label;
    };

    return (
      <div>
        <DropDownContainer>
          <DropDownHeader style={{ cursor: 'pointer' }} onClick={toggling}>
            <SdmTypography margin={0} variant={'h2Regular'}>
              {getLabel()}
            </SdmTypography>

            <DropDownArrow>
              {isOpen ? (
                <IconButton disableFocusRipple disableTouchRipple disableRipple>
                  <ArrowDropUpIcon />
                </IconButton>
              ) : (
                <IconButton disableFocusRipple disableTouchRipple disableRipple>
                  <ArrowDropDownIcon />
                </IconButton>
              )}
            </DropDownArrow>
          </DropDownHeader>
          {isOpen && (
            <DropDownListContainer>
              <DropDownList>
                {!hideResetLabel && invertResetLabel ? (
                  <ListItem onClick={() => onOptionClicked(null)} key={-1}>
                    <SdmTypography margin={0} variant={'h2Regular'}>
                      {resetLabel}
                    </SdmTypography>
                  </ListItem>
                ) : null}
                {options
                  ? options.map((option, idx) => (
                      <ListItem
                        onClick={() => onOptionClicked(option)}
                        key={idx}
                      >
                        <SdmTypography
                          margin={0}
                          variant={customFont || 'h2Regular'}
                        >
                          {optionDescriptionCallback
                            ? optionDescriptionCallback(option)
                            : option[`${labelKey}`]}
                        </SdmTypography>
                      </ListItem>
                    ))
                  : null}
                {!hideResetLabel && !invertResetLabel ? (
                  <ListItem onClick={() => onOptionClicked(null)} key={-1}>
                    <SdmTypography margin={0} variant={'h2Regular'}>
                      {resetLabel}
                    </SdmTypography>
                  </ListItem>
                ) : null}
              </DropDownList>
            </DropDownListContainer>
          )}
        </DropDownContainer>
      </div>
    );
  }
);
/* eslint-enabled */
